import { makeStyles } from 'tss-react/mui';
import { theme, colors } from '../../../theme';

/**
 * Custom hook that defines the styles for the answer component.
 */
const useAnswerStyles = makeStyles()(() => ({
  answer: {
    display: 'flex',
    flexDirection: 'row',
    margin: `${theme.margin.s} ${theme.margin.m} ${theme.margin.m} 25px`,
    padding: theme.padding.m,
    boxShadow: theme.containerShadow,
    borderRadius: theme.borderRadius.s,
    backgroundColor: theme.background.paper,
  },
  answerText: {
    width: '75%',
    fontFamily: theme.fontFamily,
  },
  answerRight: {
    'display': 'flex',
    'marginLeft': '5%',
    'minWidth': '20%',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  answerAuthorInfo: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '10px',
  },
  answerAuthor: {
    color: colors.green['400'],
    fontFamily: theme.fontFamily,
    fontWeight: theme.fontWeight.medium,
  },
  deletedAnswerAuthor: {
    color: colors.gray['300'],
    pointerEvents: 'none',
  },
  awardButton: {
    marginTop: theme.margin.xs,
    marginRight: '10px',
  },
}));

export default useAnswerStyles;
